import { ActionReducerMap } from '@ngrx/store';
import { ProductCar } from './models/productCar.model';
import { Plan } from 'src/app/models/plan.model';
import { carCheckoutReducer } from './redux/reducer/carCheckout.reducer';
import { carPlanCheckoutReducer} from './redux/reducer/carPlanCheckout.reducer';


export interface AppState{
  carCheckout: ProductCar[],
  carPlanCheckout:Plan[]
}

export const appReducers : ActionReducerMap<AppState> = {
  carCheckout : carCheckoutReducer,
  carPlanCheckout: carPlanCheckoutReducer
};
